export default __webpack_public_path__ + "static/media/lyrics_finder_plus.4d606fb0.jpg";